module.exports = __webpack_public_path__ + "fonts/interactive.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/interactive.woff2
// module id = 10
// module chunks = 0